import EvalApi from '@/api/eval/eval.js'

const state = {
    infos: [],
    industry_selected: {},
    industries: [],
    hr_industry: {},
    info_box_show: false,
    info_select_show: true,
    rate_show: false,
    positions: [],
    hr_positions: [],
    educations: [],
    rate_data: [],
    rate_info_line_1: {},
    rate_info_line_2: {},
    rate_info_line_3: {},
    rate_info_line_4: {},
    user_info: [],
    question_info: '',
    window_4_info: false,
    is_hr_worker: 1,
    is_first_hr_worker: 1,
    is_first_work : 1,
    first_industry_type: {},
    info_windows_show: [true,false,false,false,false,false,false,false,false],
}

const mutations = {
    set_is_hr_worker(state, bool){
        state.is_hr_worker = bool
    },
    set_btn_info (state, infos) {
        state.infos = infos
    },
    set_question_info (state, info) {
        state.question_info = info
    },
    set_industry_selected(state, industry){
        state.industry_selected = industry
    },
    set_rate_data(state, rate){
        state.rate_data = rate
    },
    set_rate_info(state, rate){
        state.rate_info_line_1 = rate[0]
        state.rate_info_line_2 = rate[1]
        state.rate_info_line_3 = rate[2]
        state.rate_info_line_4 = rate[3]
    },
    set_all_infos(state, info){
        state.industries = info['industry']
        state.positions = info['position']
        state.educations = info['education']
        state.hr_positions = info['hr_position']
    },
    set_hr_industry(state, industries){
        state.hr_industry = industries
    },
    set_info_box_show(state, bool){
        state.info_box_show = bool
    },
    set_select_box_show(state, bool){
        state.info_select_show = bool
    },
    set_rate_show(state, bool){
        state.rate_show = bool
    },
    set_user_info(state, info){
        state.user_info = info
    },
    set_window_4_info(state, info){
        state.window_4_info = info
    },
    set_question_window_1(state){

        let res = [{'info': '人力资源工作', 'id': 0, 'state': 0}, {'info': '非人力资源工作', 'id': 1, 'state': 0}]
        state.infos = res
        state.question_info = '您当前所从事的工作是？'

        state.info_windows_show = [true,false,false,false,false,false,false,false,false]
    },
    set_question_window_2(state, bool){
        if(bool){
            state.is_hr_worker = bool['is_hr_worker']
        }
        let res = []
        for(var x = 0; x < state.industries.length; x++ ){
            res.push({
                'info': state.industries[x]['name'],
                'id': state.industries[x]['id'],
                'state': 1,
            })
        }
        state.infos = res
        state.question_info = '您当前所从事的行业是？'
        state.info_windows_show = [false,true,false,false,false,false,false,false,false]

    },
    set_question_window_3(state, id){
        if(id){
            for(var x = 0; x < state.industries.length; x++ ){
                if(String(state.industries[x]['id']) === id){
                    state.industry_selected = state.industries[x]
                }
            }
        }

        let res = []
        if(state.is_hr_worker){
            for (let i = 0; i < state.hr_positions.length; i++) {
                res.push({
                    'info': state.hr_positions[i]['name'],
                    'id': state.hr_positions[i]['id'],
                    'state': 2,
                })
            }
        }else{
            for (let i = 0; i < state.positions.length; i++) {
                res.push({
                    'info': state.positions[i]['name'],
                    'id': state.positions[i]['id'],
                    'state': 2,
                })
            }
        }
        state.infos = res
        state.question_info = '您当前所担任的职位以及相关情况'
        state.info_windows_show = [false,false,true,false,false,false,false,false,false]
    },
    set_question_window_4(state){
        let res = [{'info': '是', 'id': 0, 'state': 3}, {'info': '否', 'id': 1, 'state': 3}]
        state.infos = res
        if (state.window_4_info){
            let name = ''
            if (state.is_hr_worker){
                for (let i = 0; i < state.hr_positions.length; i++){
                    if (state.hr_positions[i]['id'] === state.window_4_info[1]){
                        name = state.hr_positions[i]['name']
                    }
                }
            }else{
                for (let i = 0; i < state.positions.length; i++){
                    if (state.positions[i]['id'] === state.window_4_info[1]){
                        name = state.positions[i]['name']
                    }
                }
            }
            if (typeof (state.window_4_info[0]) === 'string'){
                state.question_info = '您'+state.window_4_info[0].slice(0,4) + '年所担任的'+ name +'工作是否是您的第一份工作？'
            }else{
                state.question_info = '您'+state.window_4_info[0].getFullYear() + '年所担任的'+ name +'工作是否是您的第一份工作？'
            }

        }else{
            state.question_info = '您的当前工作是否是您的第一份工作？'
        }
        // state.question_info = '您所担任职位的薪资是？'
        state.info_windows_show = [false,false,false,true,false,false,false,false,false]
    },
    set_question_window_5(state, bool){
        if(bool){
            state.is_first_work = bool['is_first_work']
        }
        let res = [{'info': '人力资源相关工作', 'id': 0, 'state': 4}, {'info': '非人力资源相关工作', 'id': 1, 'state': 4}]
        state.infos = res
        state.question_info = '您第一份工作所从事的工作是？'
        state.info_windows_show = [false,false,false,false,true,false,false,false,false]
    },
    set_question_window_6(state, bool){
        if(bool){
            state.is_first_hr_worker = bool['is_hr_worker']
        }
        let res = []
        for(var x = 0; x < state.industries.length; x++ ){
            res.push({
                'info': state.industries[x]['name'],
                'id': state.industries[x]['id'],
                'state': 5,
            })
        }
        state.infos = res
        state.question_info = '您第一份工作所从事的行业是？'
        state.info_windows_show = [false,false,false,false,false,true,false,false,false]
    },
    set_question_window_7(state, id){
        if(id){
            for(var x = 0; x < state.industries.length; x++ ){
                if(String(state.industries[x]['id']) === id){
                    state.first_industry_type = state.industries[x]
                }
            }
        }
        // let res = []
        // if(state.is_first_hr_worker){
        //     for (let i = 0; i < state.hr_positions.length; i++) {
        //         res.push({
        //             'info': state.hr_positions[i]['name'],
        //             'id': state.hr_positions[i]['id'],
        //             'state': 6,
        //         })
        //     }
        // }else{
        //     for (let i = 0; i < state.positions.length; i++) {
        //         res.push({
        //             'info': state.positions[i]['name'],
        //             'id': state.positions[i]['id'],
        //             'state': 6,
        //         })
        //     }
        // }
        // state.infos = res
        state.question_info = '您第一份工作所担任的职位以及相关情况'
        state.info_windows_show = [false,false,false,false,false,false,true,false,false]
    },
    set_question_window_8(state, bool){
        if(bool){
            state.is_first_work = bool['is_first_work']
        }
        let res = []
        for (let i = 0; i < state.educations.length; i++) {
            res.push({
                'info': state.educations[i]['name'],
                'id': state.educations[i]['id'],
                'state': 8,
            })
        }
        state.infos = res
        state.question_info = '您的学历及年龄是？'
        state.info_windows_show = [false,false,false,false,false,false,false,true,false]
    },
    // set_question_window_9(state, bool){
    //     if(bool){
    //         state.is_first_work = bool['is_first_work']
    //     }
    //     let res = []
    //     for (let i = 0; i < state.educations.length; i++) {
    //         res.push({
    //             'info': state.educations[i]['name'],
    //             'id': state.educations[i]['id'],
    //             'state': 8,
    //         })
    //
    //     }
    //     state.infos = res
    //     state.question_info = '您的学历及年龄是？'
    //     state.info_windows_show = [false,false,false,false,false,false,false,false,true]
    // },
    set_question_window_close(state){
        state.info_windows_show = [false,false,false,false,false,false,false,false,false]
    }
}
const actions = {
    async get_eval_state(context, directions){
        let res = await EvalApi.get_eval_state(directions)
        if (res.status === 200){
            return JSON.parse(res.data.result)
        }else{
            return false
        }
    },
    async set_state_btn_info (context) {
        // let res = [{'info': '从事人力资源行业', 'id': 0, 'state': 0}, {'info': '从事其他行业', 'id': 1, 'state': 0}]
        let infos = (await EvalApi.get_position_info()).data
        console.log(infos, 'js')
        if (infos['user_info']){
            context.commit('set_user_info', infos['user_info'])
        }
        context.commit('set_all_infos', infos)
        context.commit('set_question_window_1')
    },
    async previous_step (context, event) {
        let id = event.target.getAttribute('data-id')
        if (id === '1'){
            context.commit('set_question_window_1')
        }else if (id === '2'){
            context.commit('set_question_window_2')
        }else if (id === '3'){
            context.commit('set_question_window_3')
        }else if (id === '4'){
            context.commit('set_question_window_4')
        }else if (id === '5'){
            context.commit('set_question_window_5')
        }else if (id === '6'){
            context.commit('set_question_window_6')
        }else if (id === '7'){
            if(context.state.is_first_work){
                context.commit('set_question_window_4')
            }else{
                context.commit('set_question_window_7')
            }
        }
    },
    async next_step (context, event) {
        let id = event.target.getAttribute('data-id')
        if (id === '0') {
            context.commit('set_question_window_2')
        }else if(id === '1'){
            context.commit('set_question_window_3')
        }else if (id === '2'){
            context.commit('set_question_window_4')
        }else if (id === '3'){
            context.commit('set_question_window_5')
        }else if (id === '4'){
            context.commit('set_question_window_6')
        }else if (id === '5'){
            context.commit('set_question_window_7')
        }else if (id === '6'){
            context.commit('set_question_window_8')
        }else if (id === '7'){
            context.commit('set_question_window_9')
        }
    },
    async save_info (context, info) {
        info['industry_type'] = context.state.industry_selected['id']
        info['first_industry_type'] = context.state.first_industry_type['id']
        info['is_first_work'] = context.state.is_first_work
        info['is_hr_worker'] = context.state.is_hr_worker
        info['is_first_hr_worker'] = context.state.is_first_hr_worker
        console.log(info, 'eval position send')
        let rate_data = await EvalApi.post_position_info(info)
        // context.commit('set_rate_data', JSON.parse(rate_data.data['result']))
        return rate_data
    },
    async get_rate_info(context){
        await EvalApi.get_position_rate_info().then(function (data) {
            context.commit('set_rate_info', [data.data['line_1'], data.data['line_2'], data.data['line_3'], data.data['line_4']])
        })
    },
    async get_rate_info_target(context){
        await EvalApi.get_position_rate_info_target().then(function (data) {
            context.commit('set_rate_info', [data.data['line_1'], data.data['line_2'], data.data['line_3'], data.data['line_4']])
        })
    },
    async set_window_4_info(context, info){
        context.commit('set_window_4_info', info)
    },
    async click_btn (context, event) {
        let state = event.target.getAttribute('data-state')
        let id = event.target.getAttribute('data-id')
        if(state === '0'){
            if(id === '0'){
                context.commit('set_question_window_2', {'is_hr_worker': true})
            }else{
                context.commit('set_question_window_2', {'is_hr_worker': false})
            }
        }else if(state === '1'){
            context.commit('set_question_window_3', id)
        }else if(state === '3'){
            if(id === '0'){
                context.commit('set_question_window_8', {'is_first_work': true})
            }else{
                context.commit('set_question_window_5', {'is_first_work': false})
            }
        }else if(state === '4'){
            if(id === '0'){
                context.commit('set_question_window_6', {'is_hr_worker': true})
            }else{
                context.commit('set_question_window_6', {'is_hr_worker': false})
            }
        }else if(state === '5'){
            context.commit('set_question_window_7', id)
        }

        // context.commit('set_industry_selected', res)
    }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
